import React from 'react';
import {
  ParkingViolationJudgments as ParkingViolationJudgmentsModel,
  ParkingViolationJudgment,
} from 'pages/Search/models';
import { Table, Empty, Tooltip, Checkbox, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { searchIsSelectedUpdate, isSelectedSelector } from 'pages/Search';
import { TableHeader } from '..';
import {
  CommonTable,
  formatPriceString,
  AttributeValuePair,
  getDataTypeName,
  tabSelector,
} from 'common';
import { createSelector } from 'reselect';
import { ResultTypeName } from 'pages/Search/Search.types';

const { Column } = Table;

const selector = createSelector(
  tabSelector,
  isSelectedSelector,
  (tabName, getIsSelected) => ({
    tabName,
    getIsSelected,
  }),
);

const ParkingViolationJudgments: React.FC<{
  judgments: ParkingViolationJudgmentsModel;
  groupName: string;
  resultType: ResultTypeName;
  resultItemIndex: number;
}> = ({
  groupName,
  judgments: { header, items, loadDate },
  resultType,
  resultItemIndex,
}) => {
  const dispatch = useDispatch();

  const { tabName, getIsSelected } = useSelector(selector);

  const onChange = (checked: boolean, { documentType, guid }: any) => {
    dispatch(
      searchIsSelectedUpdate(
        getDataTypeName(tabName),
        documentType,
        guid,
        checked,
        resultItemIndex,
        resultType,
      ),
    );
  };

  const isSelected = React.useCallback(
    (record: any) => {
      return getIsSelected(
        getDataTypeName(tabName),
        record.documentType,
        record.guid,
        resultItemIndex,
        resultType,
      );
    },
    [getIsSelected, resultItemIndex, resultType, tabName],
  );

  return !!items.length ? (
    <>
      <TableHeader
        title={header}
        items={items}
        group={groupName}
        documentType="parkingViolationJudgments"
        tabName={tabName}
        resultType={resultType}
        resultItemIndex={resultItemIndex}
      />
      <CommonTable items={items}>
        <Column
          width="2rem"
          title=""
          render={(text: string, record: ParkingViolationJudgment) => (
            <Tooltip title={'Check for export'}>
              <Checkbox
                onChange={(e) => onChange(e.target.checked, record)}
                // @ts-ignore:
                checked={isSelected(record)}
                defaultChecked={true}
              />
            </Tooltip>
          )}
        />
        <Column title="Name" dataIndex="name" />
        <Column title="Address" dataIndex="address" />
        <Column title="# of Judg" dataIndex="jSharp" width="6rem" />
        <Column
          width="6rem"
          title="Judg Amt"
          dataIndex="jAmt"
          align="right"
          render={(text: string) => {
            return formatPriceString(parseFloat(text));
          }}
        />
        <Column
          width="6rem"
          title="Judg Int"
          dataIndex="jInt"
          align="right"
          render={(text: string) => {
            return formatPriceString(parseFloat(text));
          }}
        />
        <Column title="Plate or Sum St" dataIndex="plateSat" width="10rem" />
      </CommonTable>
      <AttributeValuePair
        attribute="Data Loaded"
        value={loadDate}
        valueType="date"
      />
    </>
  ) : (
    <>
      <Row type="flex" justify="center" align="middle">
        <Empty description={`No Judgments Found (${header})`} />
      </Row>
    </>
  );
};

export default ParkingViolationJudgments;
